import React, { useState } from "react";
import { Menu, Avatar, Typography, Layout } from "antd";
import { EditOutlined, LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import userStore from "../../zustand/store/userStore";
import EditProfile from "../../assets/icons/edit.svg"
import CourseDetails from "../../assets/icons/courseDetails.svg"
import Quiz from "../../assets/icons/quiz.svg"
import Result from "../../assets/icons/result.svg"
import HomeIcon from "../../assets/icons/dashboard.svg"
import StudentDetails from "../../assets/icons/studentDetails.svg"
import TeacherDetails from "../../assets/icons/teacherDetails.svg"
import TeacherRegister from "../../assets/icons/teacherRegister.svg"
import QuizDetails from "../../assets/icons/quizDetails.svg"
import AddCourseIcon from "../../assets/icons/addCourse.svg"

const { Title } = Typography;
const { Sider } = Layout;

const Sidebar = () => {
  const navigate = useNavigate()
  const [collapsed, setCollapsed] = useState(false);
  const { logout, user } = userStore();
  const [selectedKey, setSelectedKey] = useState("dashboard");

  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
  };
  const handleLogout = () => {
    logout()
    navigate('/login');
  }
  const navigateDashboard = () => {
    const roleRoutes = {
      student: '/student-dashboard',
      teacher: '/teacher-dashboard',
      parent: '/parent-dashboard',
      admin: '/admin-dashboard',
    };

    const path = roleRoutes[user?.role] || '/admin-dashboard';
    navigate(path);
  };
  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      className="bg-[#F6F6F6]"
      collapsed={collapsed}
      onCollapse={onCollapse}
    >
      <div style={{ padding: 20, textAlign: "center" }}>
        {!collapsed && (
          <>
            <Avatar
              size={64}
              src={user?.profilePic || undefined}
              style={{
                backgroundColor: !user?.profilePic ? '#1890ff' : undefined,
                color: '#fff',
                fontWeight: 'bold'
              }}
            >
              {!user?.profilePic && user?.fullName?.[0]}
            </Avatar>
            <Title level={5} style={{ marginTop: 10 }}>{user?.fullName}</Title>
          </>

        )}
      </div>
      <Menu theme="light" mode="inline" selectedKeys={[selectedKey]} onClick={(e) => setSelectedKey(e.key)} className="bg-[#F6F6F6] custom-menu">
        <Menu.Item key="dashboard" icon={<img src={HomeIcon} />} onClick={() => navigateDashboard()}>
          Dashboard
        </Menu.Item>
        {user.role == 'student' ? <Menu.Item key="view-course" icon={<img src={CourseDetails} />} onClick={() => navigate('/view-course')}>
          Course Details
        </Menu.Item> : null}
        {user.role == 'student' ? <Menu.Item key="enroll-course" icon={<img src={Quiz} />} onClick={() => navigate('/enroll-courses')}>
          Enroll Courses
        </Menu.Item> : null}
        {/* {user.role == 'student'? <Menu.Item key="quiz" icon={<img src={Quiz}/>} onClick={() => navigate('/quiz')}>
          Quiz Screen
        </Menu.Item>: null} */}
        {user.role == 'teacher' ? <Menu.Item key="add-course" icon={<img src={AddCourseIcon} />} onClick={() => navigate('/add-course')}>
          Add Course
        </Menu.Item> : null}
        {user.role == 'teacher' ? <Menu.Item key="course-details" icon={<img src={QuizDetails} />} onClick={() => navigate('/course-details')}>
          Course Details
        </Menu.Item> : null}
        {user.role == 'student' || user.role == 'teacher' || user.role == "admin" ? <Menu.Item key="result" icon={<img src={Result} />} onClick={() => navigate('/result')}>
          Result Screen
        </Menu.Item> : null}
        {user.role == 'admin' ? <Menu.Item key="student-details" icon={<img src={StudentDetails} />} onClick={() => navigate('/student-details')}>
          Student Details
        </Menu.Item> : null}
        {user.role == 'student' || user.role == 'teacher' || user.role == 'admin' || user.role == 'parent' ? <Menu.Item key="profile" icon={<img src={EditProfile} />} onClick={() => navigate('/profile')}>
          Edit Profile
        </Menu.Item> : null}
        {user.role == 'admin' ? <Menu.Item key="teacher-registration" icon={<img src={TeacherRegister} />} onClick={() => navigate('/teacherRegistration')}>
          Teacher Register
        </Menu.Item> : null}
        {user.role == "admin" ? <Menu.Item key="teacher-details" icon={<img src={TeacherDetails} alt="icon" />} onClick={() => navigate('/teacher-details')}>
          Teacher Details
        </Menu.Item> : null}
        {user.role == "admin" ? <Menu.Item key="announcement" icon={<EditOutlined />} onClick={() => navigate('/announcement')}>
          Announcement
        </Menu.Item> : null}

      </Menu>
      {!collapsed && (<Menu theme="light" mode="inline" className="bg-[#F6F6F6] fixed bottom-0 w-[auto] border-none">
        <Menu.Item key="logout" icon={<LogoutOutlined style={{ color: "red" }} />} onClick={() => handleLogout()}>Logout Account</Menu.Item>
      </Menu>)}
    </Sider>
  );
};

export default Sidebar;